import PropTypes from "prop-types";
import React from "react";
import Alert from "react-bootstrap/Alert";

function WsDeviceStatusConnStatus(props) {
  const { deviceStatusOnline } = props;

  if (deviceStatusOnline !== false) {
    return null;
  }

  return (
    <Alert variant="info" className="alert-muted">
      <div>
        <i className="fa fa-warning" />
        <span className="alert-text">Device status is offline.</span>
      </div>
    </Alert>
  );
}

WsDeviceStatusConnStatus.propTypes = {
  deviceStatusOnline: PropTypes.bool,
};

export { WsDeviceStatusConnStatus };
